import { LocalStorageService } from './../../../../services/local-storage.service';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppointmentComponent } from '../appointment/appointment.component';
import { ActivatedRoute } from '@angular/router';
import { OemService } from 'src/app/services/oem/oem.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-exhibitions',
  templateUrl: './exhibitions.component.html',
  styleUrls: ['./exhibitions.component.scss']
})

export class ExhibitionsComponent {
  @Input() data : any;
  itemsPerPage = 9;
  products: any[] = [];
  originalData: any[] = [];
  showNoRecordsFounds: boolean = false;
  isSignIn: boolean = false;
  @Input() brandProfileProducts: any ='Exhibitions';
  constructor(
    private localStorageService: LocalStorageService,
    private route: ActivatedRoute, 
    private fb: FormBuilder,
    public dialog: MatDialog,
    private oemService : OemService
    ) { 
      this.isSignIn = localStorageService.getItem('x-guest-token');
  }

  ngOnInit(): void {
    this.getExhibitionsByCreatedBy(this.data.id);
  }

  getFormattedDateRange(exhibitionStartDate: any, exhibitionEndDate: any): any {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };

    const start = new Date(exhibitionStartDate);
    const end = new Date(exhibitionEndDate);

    const formattedStart = start.toLocaleDateString('en-US', options);
    const formattedEnd = end.toLocaleDateString('en-US', options);

    return { startDate: `${formattedStart}`, endDate: `${formattedEnd}` };
  }

  paginatedItems: { files: string[], title: string, address: string, description: string, showMore: boolean, exhibitionStartDate: string, exhibitionEndDate: string }[] = [];

  getExhibitionsByCreatedBy(brandId: string) {
    this.oemService.getExhibitionsByCreatedBy(brandId).subscribe({
      next: (response) => {
        this.products = response.data;         
        this.products?.map((product: any) => {
          const dates = this.getFormattedDateRange(product.exhibitionStartDate, product.exhibitionEndDate);
          product.exhibitionStartDate = dates.startDate;
          product.exhibitionEndDate = dates.endDate;
        })
        this.originalData = this.products;
        if (this.products) {
          this.paginatedItems = this.products.slice(0, this.itemsPerPage);
        }
      }
    });
  }
  
  onPageChanged(paginatedData: any[]): void {
    this.paginatedItems = paginatedData;
  }

  filteredData = this.products;

  onFilteredData(filtered: any[]): void {
    this.filteredData = filtered;
    this.products = filtered;
    this.paginatedItems = this.filteredData.slice(0, this.itemsPerPage);
    if(this.paginatedItems.length == 0){ 
      this.showNoRecordsFounds = true
    } else {
      this.showNoRecordsFounds = false
    }
  }
  toggleShowMore(product: any): void {
    product.showMore = !product.showMore;
    if (product.showMore == false) {
    const topOfPage = document.querySelector('app-brand-product-filter');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    window.scroll(0, 0);
  }}

isExhibitionClosed(product: any): boolean {
  if (new Date(product.exhibitionEndDate) < new Date()) {
    return true; // If no date is provided, assume it's not closed
  }
  return false;
}

  
  
  openDialog(product : any): void {
    if(this.isSignIn){
      Swal.fire({
        icon: 'warning',
        title: 'Cannot Book an Appointment!',
        text: 'Please sign in to book an appointment',
        confirmButtonText: 'OK'
      });
    }
    else if( new Date(product.exhibitionEndDate) < new Date() ){
      Swal.fire({
        icon: 'warning',
        title: 'The exhibition has ended.!',
        confirmButtonText: 'OK'
      });
    }
    else{

      const dialogRef = this.dialog.open(AppointmentComponent, {
        width: '550px',
        height: 'max-content',
        data : product,
        autoFocus: false,
        position: { top: '10vh'}
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    } 
  }
  sanitizeUrl(url: string): void {
    if (!url) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  

}
